/*
 * @Descripttion:
 * @Author: liang
 * @Date: 2020-09-11 17:22:16
 * @LastEditors: liang
 * @LastEditTime: 2024-07-10 14:38:36
 */
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home.vue"),
    redirect: { name: "index" },
    children: [
      {
        path: "/index",
        component: () => import("@/views/index.vue"),
        name: "index",
        meta: { title: "首页" }
      },
      {
        path: "/about/about",
        component: () => import("@/views/about/about.vue"),
        name: "summary",
        meta: { title: "公司概况" }
      },
      {
        path: "/notice/notice",
        component: () => import("@/views/notice/notice.vue"),
        name: "notice",
        meta: { title: "公告公示" }
      },
      {
        path: "/notice/noticeinfo",
        component: () => import("@/views/notice/noticeinfo.vue"),
        name: "websitebusiness",
        meta: { title: "公告公示" }
      },
      {
        path: "/news/news",
        component: () => import("@/views/news/news.vue"),
        name: "news",
        meta: { title: "新闻资讯" }
      },
      {
        path: "/news/newsinfo",
        component: () => import("@/views/news/newsinfo.vue"),
        name: "news",
        meta: { title: "新闻资讯" }
      },
      {
        path: "/policy/policy",
        component: () => import("@/views/policy/policy.vue"),
        name: "zcfglx",
        meta: { title: "政策法规" }
      },
      {
        path: "/policy/policyinfo",
        component: () => import("@/views/policy/policyinfo.vue"),
        name: "zcfglx",
        meta: { title: "政策法规" }
      },
      {
        path: "/service/service",
        component: () => import("@/views/service/service.vue"),
        name: "download",
        meta: { title: "下载中心" }
      },
      {
        path: "/service/serviceinfo",
        component: () => import("@/views/service/serviceinfo.vue"),
        name: "download",
        meta: { title: "下载中心" }
      },
      {
        path: "/recruit/recruit",
        component: () => import("@/views/recruit/recruit.vue"),
        name: "joinus",
        meta: { title: "公司招聘" }
      },
      {
        path: "/contact/contact",
        component: () => import("@/views/contact/contact.vue"),
        name: "contact",
        meta: { title: "联系我们" }
      },
      {
        path: "/websitebusiness/websitebusiness",
        component: () => import("@/views/websitebusiness/websitebusiness.vue"),
        name: "websitebusiness",
        meta: { title: "招标业务" }
      },
      {
        path: "/hxwebsiteconsult/hxwebsiteconsultgc",
        component: () => import("@/views/hxwebsiteconsult/hxwebsiteconsultgc.vue"),
        name: "websitegczx",
        meta: { title: "工程咨询" }
      },
      {
        path: "/hxwebsiteconsult/hxwebsiteconsultzj",
        component: () => import("@/views/hxwebsiteconsult/hxwebsiteconsultzj.vue"),
        name: "websitezjzx",
        meta: { title: "造价咨询" }
      },
      {
        path: "/elsebusiness/elsebusiness",
        component: () => import("@/views/elsebusiness/elsebusiness.vue"),
        name: "elsebusiness",
        meta: {
          title: "其他业务"
        }
      }
      // {
      //   path: "/secondnav",
      //   component: () => import("@/views/secondnav.vue"),
      //   name: "secondnav",
      //   children: [
      //     {
      //       path: "/about/about",
      //       component: () => import("@/views/about/about.vue"),
      //       name: "about",
      //       meta: { title: "公司概况" }
      //     }
      //   ]
      // }
    ]
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
